import React, { useState, useEffect } from 'react';
import logo from '../assets/GiftBoxLogo.svg';
import { removeCookie } from '../Functions'
import usericon from '../assets/icons/27e06fbd92f13d40bb41991bcd741a47.svg';

import usericon_2 from '../assets/icons/8664831_user_icon.svg';
import history_icon from '../assets/history.svg';
import heart from '../assets/icons/8530571_heart_icon.svg';

import { useLocation } from "react-router-dom";

export default function Navbar() {

    const [userData, setUserData] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const location = useLocation(); // Get current URL path
    const [activeTab, setActiveTab] = useState(location.pathname);

    useEffect(() => {
        setActiveTab(location.pathname); // Update active tab on route change
    }, [location]);



    useEffect(() => {
        // Check if the data exists in sessionStorage
        const storedData = sessionStorage.getItem('gbx_data');
        if (storedData) {
            setUserData(JSON.parse(storedData));
            setShowDropdown(true)
            console.log(userData)
        }
    }, []);




    const handleSignOut = () => {
        // Clear the sessionStorage and reset the user data
        sessionStorage.removeItem('gbx_data');
        setUserData(null);
        removeCookie("gbx_uid")
        window.location.href = '/signin'; // Redirect to sign-in page
    };

    return (
        <nav className="navbar navbar-expand-lg bg-body-tertiary  fixed-top p-0">
            <div className="container">
                {/* Logo */}
                <a className="navbar-brand my-2" href="/">
                    <img src={logo} alt="Logo" />
                </a>

                {/* Toggler Button (For Mobile) */}
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                {/* Collapsible Navbar Content */}
                <div className="collapse navbar-collapse justify-content-end" id="navbarNav">

                    <ul className="navbar-nav d-flex gap-3 my-2">
                        <li className="nav-item ">
                            <a className={`nav-link p-0 ${activeTab === "/" ? "active" : ""}`}
                                href="/"> Home
                            </a>
                        </li>
                        <li className="nav-item ">
                            <a className={`nav-link  p-0 ${activeTab === "/products" ? "active" : ""}`}
                                href="/products">Products
                            </a>
                        </li>
                        <li className="nav-item ">
                            <a className={`nav-link  p-0 ${activeTab === "/contact" ? "active" : ""}`}
                                href="/contact">Contact Us
                            </a>
                        </li>
                    </ul>

                    {/* Sign In Button */}


                    {!showDropdown ?
                        <button
                            className="btn bg_purple_light primary_purple bold br_5 d-flex align-items-center gap-2 my-2"
                            type="button" >

                            <div className='d-flex flex-row gap-3' >
                                <img src={usericon} alt="User Icon" />
                                <p onClick={() => window.location.href = '/signin'} style={{ color: "#6D4EEC" }}>Sign In</p>
                            </div>

                        </button>

                        :
                        <div class="dropdown my-2">

                            <button class="btn bg_purple_light primary_purple bold br_5 dropdown-toggle d-flex flex-row align-items-center gap-3" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <p className='avatar' >{userData.user.first_name!="" ? userData.user.first_name[0].toUpperCase():''}</p>
                                <p style={{ color: "#6D4EEC" }}>{userData.user.first_name}</p>
                            </button>

                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item" href="/profile/settings"> <img src={usericon_2} /> Settings</a></li>
                                <li><a class="dropdown-item" href="/profile/history"><img src={history_icon} /> Voucher History</a></li>
                                <li><a class="dropdown-item" href="/profile/favorites"><img src={heart} /> Favorites</a></li>

                                <li><a class="dropdown-item" onClick={() => handleSignOut()}>Sign Out</a></li>

                            </ul>
                        </div>}



                </div>
            </div>
        </nav>
    );
}
